module.exports = __webpack_public_path__ + "img/ipad-mobile_cn.ea6455f.jpg";